import React from "react";
import "./home.css";
import Body from "../body/index";



function Home() {
  return ( 
          <div className="home">
            <Body />
          </div>
  );
}

export default Home;